import { useEffect } from 'react';

import { NfcTag } from '~features/nfc';

import SkcUsersAndNfcTagsAutocomplete from './skcUsersAndNfcTagsAutocomplete';
import useUrlSearchParamsSkcUsersAndNfcTags from '../../hooks/useUrlSearchParamsSkcUsersAndNfcTags';

interface SkcUsersAndNfcTagsFilterProps {
	label?: string;
	defaultKeyId?: string;
	organisationId?: string;
	count?: number;
	onChange?: (value: NfcTag) => void;
	includeUsers?: boolean;
}

const SkcUsersAndNfcTagsFilter = ({
	defaultKeyId,
	onChange,
	organisationId,
	...skcUsersAndNfcTagsAutocompleteProps
}: SkcUsersAndNfcTagsFilterProps) => {
	const [nfcTag, setNfcTag] = useUrlSearchParamsSkcUsersAndNfcTags();

	// TODO: this feels a bit tricky. Multiple sources of truth, look into
	// making this more reliable or taking the SkcUsersAndNfcTagsFilter
	// as the source of truth
	useEffect(() => {
		if (!skcUsersAndNfcTagsAutocompleteProps.value && nfcTag != null) {
			setNfcTag(null);
		}
	}, [skcUsersAndNfcTagsAutocompleteProps.value, setNfcTag, nfcTag]);

	const handleChange = (value: NfcTag) => {
		setNfcTag(value);
		onChange?.(value);
	};

	return (
		<SkcUsersAndNfcTagsAutocomplete
			{...skcUsersAndNfcTagsAutocompleteProps}
			value={nfcTag}
			organisationId={organisationId}
			onChange={(_, newValue) => handleChange(newValue)}
		/>
	);
};

export default SkcUsersAndNfcTagsFilter;
